@if (statisticData) {
  <app-statistic-list
    [sectionID]="sectionID().id"
    [productID]="sectionID().product"
    [selectedPeriod]="selectedPeriod()"
    [selectedBenchmark]="selectedBenchmark()">
  </app-statistic-list>
}

@if (contentBlocks) {
  <div>
    @for (item of contentBlocks; track item) {
      <!-- List Items -->
      @for (el of item.translations[currentLanguage].content_rendered; track el.id) {
        @if (el.type === 'paragraph') {
          <app-block-style-paragraph [data]="el"></app-block-style-paragraph>
        }
        @if (el.type === 'header') {
          <app-block-style-header [data]="el"></app-block-style-header>
        }
        @if (el.type === 'list') {
          <app-block-style-list [data]="el"></app-block-style-list>
        }
        @if (el.type === 'table') {
          <app-block-style-table [data]="el"></app-block-style-table>
        }
        @if (el.type === 'image') {
          <app-simple-image [data]="el"></app-simple-image>
        }
      }
    }
  </div>
}
